const DATABASE = 'realimager-share-intake';
const STORE = 'files';

function openShareDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE, { autoIncrement: true });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function stashSharedFiles(files: File[]): Promise<void> {
  if (!files.length) return;
  const database = await openShareDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE, 'readwrite');
    for (const file of files) transaction.objectStore(STORE).add(file);
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
  database.close();
}

export async function takeSharedFiles(): Promise<File[]> {
  if (!('indexedDB' in globalThis)) return [];
  const database = await openShareDatabase();
  const files = await new Promise<File[]>((resolve, reject) => {
    const transaction = database.transaction(STORE, 'readwrite');
    const request = transaction.objectStore(STORE).getAll();
    request.onsuccess = () => {
      transaction.objectStore(STORE).clear();
      resolve(request.result as File[]);
    };
    request.onerror = () => reject(request.error);
  });
  database.close();
  return files;
}
